<div class="btn-group mr-3">
  <div *ngFor="let x of flags">
    <button type="button" class="btn btn-sm btn-light" (click)="flagItems(x)">
      <i [ngClass]="x.dropdownClass || x.iconClass"></i> {{x.dropdownDescription || x.description}}
    </button>
  </div>
</div>